// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fetchFrequencyPolarizations } from 'helpers/api'
import { addFrequencySettings } from 'redux/modules/domain'
import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'
import catchEmptySettings from './catchEmptySettings'

const fetchAndAddFrequencySettings = () => async dispatch => {
  const settings = [
    fetchFrequencyPolarizations(),
  ]

  let r

  try {
    r = await Promise.all(settings)
  } catch (err) {
    console.warn(err)
    dispatch(settingsFailedToLoadMessage('Frequency', err))
    return {}
  }

  const polarizations = r[0].entities

  const frequencySettings = {
    polarizations,
  }

  dispatch(catchEmptySettings('Frequency', frequencySettings))
  dispatch(addFrequencySettings(frequencySettings))
  return frequencySettings
}

export default fetchAndAddFrequencySettings
